"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CircleCheckIconThin = function CircleCheckIconThin(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "23",
    height: "24",
    viewBox: "0 0 23 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.9524 17.8824C9.58504 17.8824 9.2956 17.7177 8.99503 17.3294L5.87802 13.2589C5.72217 13.0353 5.62198 12.7883 5.62198 12.5294C5.62198 12 6.0116 11.5765 6.50142 11.5765C6.80199 11.5765 7.06916 11.7059 7.31407 12.0589L9.89674 15.5883L14.9285 7.08239C15.1289 6.72945 15.4072 6.55298 15.7077 6.55298C16.1753 6.55298 16.6206 6.88239 16.6206 7.42357C16.6206 7.68239 16.487 7.95298 16.3534 8.18827L10.8541 17.3294C10.6203 17.6942 10.3198 17.8824 9.9524 17.8824Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3548 24C17.5555 24 22.7097 18.5647 22.7097 12C22.7097 5.44706 17.5443 0 11.3437 0C5.13194 0 0 5.44706 0 12C0 18.5647 5.14307 24 11.3548 24ZM11.3494 22.2074C5.986 22.2074 1.70212 17.6681 1.70212 12C1.70212 6.3439 5.97463 1.7926 11.338 1.7926C16.69 1.7926 20.9966 6.3439 21.008 12C21.0193 17.6681 16.7014 22.2074 11.3494 22.2074Z"
  }));
};
var _default = CircleCheckIconThin;
exports.default = _default;